module.exports = __webpack_public_path__ + "static/sung-f496a3857ff41252a53dc25f54e20a9b.jpg";